module Sm.UI.Components.AppView

open MobF.React
open Fable.React
open Fable.React.Props

open Sm.UI.App
open Sm.UI.Components.MainView

[<ObserverComponent>]
let AppView (props: {| App: AppModel |}) =
    let app = props.App

    if app.State.Halted then
        fragment [] [
            dialog [Class "is-light is-primary"; Open true] [
                label [] [str "An error has occurred, and the app can not continue.."]
                p [] [str "The app has been suspended to prevent data loss, and must be reloaded. If the problem persists, please contact support."]

                let onClick _ = Browser.Dom.window.location.reload()
                button [OnClick onClick] [str "Reload"]
            ]
        ]
    else
        match app.Computed.Screen with
        | Login model -> Login.Login {| Login = model |}
        | Loading -> Message.Loading
        | Warning message -> Message.Warning message
        | Main model -> MainView { Main = model }
